import { combineReducers } from 'redux';
import workerReport from 'store/reducers/workerReport/workerReport';
import workerReportFilters from 'store/reducers/workerReport/workerReportFilters';
import workerReportExcel from 'store/reducers/workerReport/workerReportExcel';

export default combineReducers({
  workerReport,
  workerReportFilters,
  workerReportExcel
});